export default {
  '/ru/moscow/catalog': {
    description:
      'Каталог товаров для аренды в Москве на Polka. Найдите всё необходимое: от бытовой техники до спортивного инвентаря. Удобный поиск, фильтры и подробные описания товаров.',
  },
  '/ru/moscow/catalog?page=10': {
    description:
      'Каталог товаров для аренды в Москве — страница 10. Продолжайте поиск нужных вещей на Polka. Широкий выбор, удобные фильтры и подробные описания.',
  },
  '/ru/moscow/catalog?page=11': {
    description:
      'Каталог товаров для аренды в Москве — страница 11. Найдите подходящие товары среди тысяч предложений на Polka. Удобный интерфейс и быстрый поиск.',
  },
  '/ru/moscow/catalog?page=12': {
    description:
      'Каталог товаров для аренды в Москве — страница 12. Исследуйте новые предложения на Polka. От бытовой техники до спортивного инвентаря — всё в одном месте.',
  },
  '/ru/moscow/catalog?page=13': {
    description:
      'Каталог товаров для аренды в Москве — страница 13. Продолжайте поиск нужных вещей на Polka. Удобные фильтры и подробные описания товаров.',
  },
  '/ru/moscow/catalog?page=14': {
    description:
      'Каталог товаров для аренды в Москве — страница 14. Найдите всё необходимое для дома, отдыха или работы на Polka. Широкий выбор и выгодные условия.',
  },
  '/ru/moscow/catalog?page=15': {
    description:
      'Каталог товаров для аренды в Москве — страница 15. Исследуйте новые предложения на Polka. Удобный поиск и подробные описания товаров.',
  },
  '/ru/moscow/catalog?page=16': {
    description:
      'Каталог товаров для аренды в Москве — страница 16. Продолжайте поиск нужных вещей на Polka. Широкий выбор и удобные условия аренды.',
  },
  '/ru/moscow/catalog?page=17': {
    description:
      'Каталог товаров для аренды в Москве — страница 17. Найдите подходящие товары среди тысяч предложений на Polka. Удобный интерфейс и быстрый поиск.',
  },
  '/ru/moscow/catalog?page=18': {
    description:
      'Каталог товаров для аренды в Москве — страница 18. Исследуйте новые предложения на Polka. От бытовой техники до спортивного инвентаря — всё в одном месте.',
  },
  '/ru/moscow/catalog?page=19': {
    description:
      'Каталог товаров для аренды в Москве — страница 19. Продолжайте поиск нужных вещей на Polka. Удобные фильтры и подробные описания товаров.',
  },
  '/ru/moscow/catalog?page=2': {
    description:
      'Каталог товаров для аренды в Москве — страница 2. Найдите всё необходимое для дома, отдыха или работы на Polka. Широкий выбор и выгодные условия.',
  },
  '/ru/moscow/catalog?page=20': {
    description:
      'Каталог товаров для аренды в Москве — страница 20. Исследуйте новые предложения на Polka. Удобный поиск и подробные описания товаров.',
  },
  '/ru/moscow/catalog?page=21': {
    description:
      'Каталог товаров для аренды в Москве — страница 21. Продолжайте поиск нужных вещей на Polka. Широкий выбор и удобные условия аренды.',
  },
  '/ru/moscow/catalog?page=22': {
    description:
      'Каталог товаров для аренды в Москве — страница 22. Найдите подходящие товары среди тысяч предложений на Polka. Удобный интерфейс и быстрый поиск.',
  },
  '/ru/moscow/catalog?page=23': {
    description:
      'Каталог товаров для аренды в Москве — страница 23. Исследуйте новые предложения на Polka. От бытовой техники до спортивного инвентаря — всё в одном месте.',
  },
  '/ru/moscow/catalog?page=3': {
    description:
      'Каталог товаров для аренды в Москве — страница 3. Продолжайте поиск нужных вещей на Polka. Удобные фильтры и подробные описания товаров.',
  },
  '/ru/moscow/catalog?page=4': {
    description:
      'Каталог товаров для аренды в Москве — страница 4. Найдите всё необходимое для дома, отдыха или работы на Polka. Широкий выбор и выгодные условия.',
  },
  '/ru/moscow/catalog?page=5': {
    description:
      'Каталог товаров для аренды в Москве — страница 5. Исследуйте новые предложения на Polka. Удобный поиск и подробные описания товаров.',
  },
  '/ru/moscow/catalog?page=6': {
    description:
      'Каталог товаров для аренды в Москве — страница 6. Продолжайте поиск нужных вещей на Polka. Широкий выбор и удобные условия аренды.',
  },
  '/ru/moscow/catalog?page=7': {
    description:
      'Каталог товаров для аренды в Москве — страница 7. Найдите подходящие товары среди тысяч предложений на Polka. Удобный интерфейс и быстрый поиск.',
  },
  '/ru/moscow/catalog?page=8': {
    description:
      'Каталог товаров для аренды в Москве — страница 8. Исследуйте новые предложения на Polka. От бытовой техники до спортивного инвентаря — всё в одном месте.',
  },
  '/ru/moscow/catalog?page=9': {
    description:
      'Каталог товаров для аренды в Москве — страница 9. Продолжайте поиск нужных вещей на Polka. Удобные фильтры и подробные описания товаров.',
  },
}
